/* Mount only after the real HUD is visible. The caller passes the server count. */
(function(global){
 'use strict';let controller=null;
 global.mountMynticRacha=function(initial=0){
  if(controller)return controller;
  const root=document.getElementById('ce-streak-box');
  const value=document.getElementById('ce-hstreak');
  if(!root||!value)throw new Error('No se encontró el HUD de Coleccionista Experto.');
  const width=root.getBoundingClientRect().width;
  if(!width)throw new Error('Monta RACHA después de mostrar #ce-play.');
  // Freeze the existing grid column, so 99 → 100 cannot move the other stats.
  const priorWidth=root.style.width;
  root.style.width=width+'px';
  controller=global.MynticStreak.create(root,{valueElement:value,labelElement:root.querySelector('i'),initial});
  const dispose=controller.destroy.bind(controller);
  controller.destroy=()=>{dispose();root.style.width=priorWidth;controller=null;};
  return controller;
 };
})(window);
